import axios from '../axios'
import appConfig from 'app.config'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { logError } from 'shared/AppInsight'
import { DecreaseLimitResponse } from './decreaseLimit'

export enum MaritalStatus {
	Single = 'Single',
	Married = 'Married',
	Divorced = 'Divorced',
	Widow = 'Widow',
	Cohabitee = 'Cohabitee',
}

export enum AccommodationType {
	Renter = 'Renter',
	Owner = 'Owner',
	WithParents = 'WithParents',
}

export enum OccupationType {
	Permanent = 'Permanent',
	PartTime = 'PartTime',
	Entrepreneur = 'Entrepreneur',
	Unemployed = 'Unemployed',
	Student = 'Student',
	SickLeave = 'SickLeave',
	Retired = 'Retired',
	Housewife = 'Housewife',
	Other = 'Other',
}

export interface IncreaseLimitParams {
	desiredLimit: number
	ssn: string
	email: string
	mobileNumber: string
	maritalStatus: MaritalStatus
	occupationType: OccupationType
	netMonthlyIncome: number
	childrenInHousehold: number
	accomodationType: AccommodationType
	totalMortgageCosts: number
	monthlyMortgageCosts: number
	rentalCosts: number
	hasCarLoan: boolean
	totalCarLoan: number
	montlyCarLoanCost: number
	partyId: string
}

export async function increaseLimit(params: IncreaseLimitParams) {
	return axios
		.post<DecreaseLimitResponse>(
			`${appConfig.customerDataBaseUrl}/api/limit/increase`,
			params,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
